const statesOptions = [
  { value: "Nová" },
  { value: "Hotová" },
  { value: "Aktivní" },
  { value: "Zrušená" },
];

const personOptions = [
  { value: "Krčmářová" },
  { value: "Petřík" },
  { value: "Bartoš" },
  { value: "Štěpánek ml." },
  { value: "Štěpánek st." },
  { value: "Vejnar" },
];

export default { statesOptions, personOptions };
